module.exports = __webpack_public_path__ + "static/media/ic_hearing_link.41e7fd38.svg";